const messages = {
    accountBox: {
        title: "Prehľad",
        description: "Rýchlo sledujte svoje akcie a body.",
        button: "OTVORIŤ PREHĽAD",
    },
};

export default {
    messages,
};
